import React, { useEffect } from 'react';
import type { ITablaContratosVistaProps } from '../interfaces';
// import { Group, Text, Button, Box } from '@mantine/core';
// import {
//   IconPlus
// } from "@tabler/icons-react";
import Tabla from '../../../globales/componentes/tabla/tabla';
import { ActionIcon, Box, Group, Tooltip } from '@mantine/core';
import FiltroContratosVista from './filtroContratosVista';
import { IconFilter, IconFilterFilled, IconRefresh } from '@tabler/icons-react';

const TablaContratosVista: React.FunctionComponent<ITablaContratosVistaProps> = ({ 
  tabla, 
  consultarContratos, 
  filtro,
  manejarCambioFiltroContrato,
  manejarHabilitarFiltros,
  habilitarFiltros,
  indicePagina,
  TAMANIO_PAGINA
}) => {

  useEffect(() => {
    consultarContratos(tabla.getState().pagination.pageIndex, tabla.getState().pagination.pageSize);
  }, [])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
      {/* Cabezal de Filtros y Botones */}
      <div style={{ marginBottom: '10px' }}>
        <Group justify="space-between" w="100%">
          <Box style={{ flex: 1, minWidth: 0 }}>
            {habilitarFiltros && (
              <FiltroContratosVista
                consultarContratos={() => consultarContratos(indicePagina, TAMANIO_PAGINA)}
                filtro={filtro}
                manejarCambioFiltroContrato={manejarCambioFiltroContrato}
              />
            )}
          </Box>
          <Group gap={4}>
            <Tooltip
              label="Refrescar"
              withinPortal
              openDelay={100}
              zIndex={9999}
              style={{ fontSize: '10px', padding: '3px 5px' }}
            >
              <ActionIcon
                variant="subtle"
                color="primary"
                radius="xl"
                onClick={() => consultarContratos(indicePagina, TAMANIO_PAGINA)}
              >
                <IconRefresh size={16} />
              </ActionIcon>
            </Tooltip>
            <Tooltip
              label="Filtrar"
              withinPortal
              openDelay={100}
              zIndex={9999}
              style={{ fontSize: "10px", padding: '3px 5px' }}
            >
              <ActionIcon
                variant="subtle"
                color="primary"
                radius="xl"
                onClick={() => manejarHabilitarFiltros(!habilitarFiltros)}
              >
                {habilitarFiltros ? <IconFilterFilled size={16} /> : <IconFilter size={16} />}
              </ActionIcon>
            </Tooltip>
          </Group>
        </Group>
      </div>
        <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        <Tabla
          tabla={tabla}
        />
      </div>
    </div>
      );
};

      export default TablaContratosVista;
